<template>
  <div class="orderPage">
    <div class="card_list">
      <div class="card_item flex-colc" @click="handleGo('/orderComplain')" v-if="deptObj.iscs == 1">
        <p>送餐业务</p>
        <p>订单投诉管理</p>
      </div>
      <div class="card_item flex-colc" @click="handleGo('/orderDataManage')" v-if="deptObj.ismanager == 1">
        <p>送餐业务</p>
        <p>合作餐厅订单数据统计</p>
      </div>
      <div class="card_item flex-colc" @click="handleGo('/subzoneDataList')" v-if="deptObj.ismanager == 1">
        <p>送餐业务</p>
        <p>分区订单数据统计</p>
      </div>
      <div class="card_item flex-colc" @click="handleGo('/parkFlash/pOrderMineListManage')" v-if="deptObj.iscs == 1">
        <p>跑腿业务</p>
        <p>订单服务管理</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "serviceMange",
  data() {
    return {
      show: false,
      deptObj: "",
    };
  },
  computed: {
    ...mapState(["USERINFO"]),
  },
  created() {
    this.deptObj = this.USERINFO.dept[0];
  },
  methods: {
    handleGo(name) {
      this.$router.push(name);
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 140px;
  .card_list {
    .card_item {
      width: 660px;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 9px 30px 0px rgba(4, 0, 0, 0.09);
      border-radius: 40px;
      font-size: 28px;
      color: #000000;
      margin: auto;
      padding: 0 45px;
      box-sizing: border-box;
      margin-bottom: 50px;
      p {
        line-height: 40px;
      }
      
    }
  }
}
</style>